import {useEffect, useRef, useState} from "react";
import videojs from "video.js";
import Box from "@mui/material/Box";

export default function  KeyMomentWindowsPlayer({dispose,live = false, trimPoints, changeVideoTime, setVideoRef, currentFocusElement, shortcuts, moveTrimPoint , isPlaying, muted, onCanPlay = () => {}, setIsPlaying, setVideoDuration, loop, onEnded, setVideoTime, url}) {

    const videoRef = useRef(null);
    const playerRef = useRef(null);
    const frameRateInterval = useRef(undefined);
    const focusRef = useRef();
    const durationRef = useRef(0);
    const [durationReady, setDurationReady] = useState(false);
    const trimPointsRef = useRef([])

    const shortcutAmount = 5;

    useEffect(() => {
        if(trimPoints){
            trimPointsRef.current = trimPoints
        }
    }, [trimPoints]);

    useEffect(() => {
        if (changeVideoTime!==undefined && playerRef.current){
            playerRef.current.currentTime(changeVideoTime);
        }
    }, [changeVideoTime]);

    useEffect(() => {
        if (!isPlaying){
            playerRef.current?.pause();
        }else{
            playerRef.current?.play();
        }
    }, [isPlaying]);

    useEffect(() => {
        if (!muted){
            playerRef.current?.muted(true);
        }else{
            playerRef.current?.muted(false);
        }
    }, [muted])

    const tryFreeze = () => {
        const tech = playerRef.current.tech();
        setVideoDuration(playerRef.current.currentTime())
        setDurationReady(true)
        durationRef.current = playerRef.current.duration()
        playerRef.current.currentTime(0)
        setVideoTime(0)


        if (tech?.vhs?.masterPlaylistLoader_) {
            const loader = tech.vhs.masterPlaylistLoader_;
            loader.off('loadedplaylist');
            loader.on('loadedplaylist', () => {
                loader.refresh = () => {};
            });

            if (loader.media_) {
                loader.refresh = () => {};
            }
        } else {
            console.warn('❌ Nessun VHS loader trovato ancora.');
        }
    };

    const initPlayer = () => {
        if (videoRef && videoRef.current && url && !playerRef.current) {
            playerRef.current = videojs(videoRef.current, {
                controls: false,
                preload: 'auto',
                liveui: true,
                sources: [{
                    src: url,
                    type: 'application/x-mpegURL'
                }]
            });
            playerRef.current.on('canplaythrough', onCanPlay)
            if (setVideoDuration) {
                playerRef.current.on('loadedmetadata', () => {
                    if(live){
                        tryFreeze()
                    }else{
                        if (!durationRef.current || durationRef.current === Infinity ){
                            durationRef.current = playerRef.current.duration()
                            setVideoDuration(playerRef.current.duration())
                            setTimeout(() => setDurationReady(true), 3000)
                            playerRef.current?.muted(!muted);
                        }
                    }
                });
            }
            playerRef.current.on('stop', () => {clearInterval(frameRateInterval.current); frameRateInterval.current = undefined;});
            playerRef.current.on('pause', () => {clearInterval(frameRateInterval.current); frameRateInterval.current = undefined;});
            playerRef.current.on('ended', () => {
                if (setIsPlaying && !loop)
                    setIsPlaying(false);
                if (setIsPlaying && loop){
                    playerRef.current.play();
                    setIsPlaying(true);
                }
                if (onEnded) {
                    onEnded()
                }
            });
            playerRef.current.on('play', () => {
                const intervalId = setInterval(() => {
                    if (setVideoTime && durationRef.current > 0 && durationRef.current !== Infinity) {
                        setVideoTime(playerRef.current.currentTime());
                    }
                }, 500);
                frameRateInterval.current= intervalId;
            });
            if(live){
                playerRef.current.play().then(() => {
                    setIsPlaying(true)
                });
            }

            setTimeout(() => {
                if (!durationRef.current || durationRef.current === Infinity){
                    playerRef.current?.muted(true)
                    playerRef.current.play().then(() => {
                        playerRef.current.currentTime(0)
                        playerRef.current.pause()
                        playerRef.current?.muted(!muted)
                        setVideoTime(0)
                        const classicDuration = playerRef.current.duration()
                        if (classicDuration !== Infinity){
                            setDurationReady(true)
                            durationRef.current = playerRef.current.duration()
                            setVideoDuration(playerRef.current.duration())
                        }else{
                            const tech = playerRef.current.tech({ IWillNotUseThisInPlugins: true });
                            const vhs = tech?.vhs;
                            const playlist = vhs.playlists.media();
                            if (playlist?.segments?.length) {
                                const lastSegment = playlist.segments[playlist.segments.length - 1];
                                const endTime =
                                    (lastSegment.start != null)
                                        ? lastSegment.start + lastSegment.duration
                                        : playlist.segments.reduce((t, s) => t + s.duration, 0);
                                durationRef.current = endTime;
                                setVideoDuration(endTime)
                                setTimeout(() => {
                                    setDurationReady(true)
                                }, 3000)
                            }
                        }
                    })
                }
            }, 3000)
            //playerRef.current.on('ready', tryFreeze);
        }
    }

    useEffect(() => {
        if (setVideoRef && videoRef.current) {
            setVideoRef(videoRef.current);
        }
    }, [videoRef]);



    useEffect(() => {
        focusRef.current = currentFocusElement
    }, [currentFocusElement]);

    useEffect(initPlayer, [url]);

    function movePlayerBar(amount, direction){
        let videoTime = playerRef.current.currentTime();
        videoTime = videoTime + (amount * direction);
        videoTime = videoTime < 0 ? 0 : videoTime;
        videoTime = videoTime > playerRef.current.duration() ? playerRef.current.duration() : videoTime;
        playerRef.current.currentTime(videoTime);
        if (setVideoTime) {
            setVideoTime(videoTime);
        }
    }

    function changePlayState(){
        if (playerRef.current.paused()){
            if (trimPointsRef.current && trimPointsRef.current.length > 0){
                const lastPossibleTrimPoints =  trimPointsRef.current[trimPointsRef.current.length - 1];
                const endTime = Math.trunc(lastPossibleTrimPoints.end * 1000) / 1000;
                const startTime = trimPointsRef.current[0].start
                const videoTime = Math.trunc(playerRef.current.currentTime() * 1000) / 1000;
                if (endTime === videoTime){
                    playerRef.current.currentTime(startTime)
                }
            }
            playerRef.current.play();
            if (setIsPlaying){
                setIsPlaying(true);
            }
        }else{
            playerRef.current.pause();
            if (setIsPlaying){
                setIsPlaying(false);
            }
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', handleWindowKeyDown);

        return () => {
            window.removeEventListener('keydown', handleWindowKeyDown);
        }
    }, [])

    function handleWindowKeyDown(event){
        if(shortcuts){
            if (event.key === " "){
                changePlayState();

            }
            else if (event.ctrlKey){
                if (event.key === 'ArrowRight' || event.key === 'ArrowLeft'){
                    const direction = event.key === 'ArrowRight' ? 1 : -1;
                    const amount = event.shiftKey ? 10 : 1;
                }
            }else if(event.key === 'ArrowRight' || event.key === 'ArrowLeft'){
                if (focusRef.current.type !== 'startGrabber' && focusRef.current.type !== 'endGrabber'){
                    const direction = event.key === 'ArrowRight' ? 1 : -1;
                    const amount = event.shiftKey ? 12 * (shortcutAmount) : (shortcutAmount);
                    movePlayerBar(amount, direction);
                    //Else move the selected Grab
                }else{
                    if (moveTrimPoint){
                        const trimPointType = focusRef.current.type === 'startGrabber' ? 'start' : 'end';
                        const direction = event.key === 'ArrowRight' ? 1 : -1;
                        const amount = event.shiftKey ? 12 * (shortcutAmount) : (shortcutAmount);
                        moveTrimPoint(amount, direction, focusRef.current.index, trimPointType, event.shiftKey);
                    }
                }
            }
        }
    }

    useEffect(() => {
        if(dispose && playerRef.current){
            playerRef.current.pause();
            playerRef.current.dispose();
            playerRef.current = null;
        }
        if(dispose && frameRateInterval.current){
            clearInterval(frameRateInterval.current)
            clearInterval.current = undefined
        }
    }, [dispose]);


    return (

        <Box position="relative" sx={{opacity: durationReady ? 1 : 0}}>
            <video crossOrigin="anonymous" ref={videoRef} style={{width: '100%', height: 'auto', }}></video>
        </Box>
    )
}